import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import React from "react";
import { ITheme } from "../../utils/theme";

interface ICheckboxFieldProps {
  label: string | JSX.Element;
  fieldKey: string;
  value: boolean;
  onChange: (key: string, value: boolean) => void;
  required?: boolean;
  error?: JSX.Element | string;
}

export const CheckboxField: React.FC<ICheckboxFieldProps> = ({
  label,
  fieldKey,
  value,
  onChange,
  required = false,
  error = ''
}) => (
  <Box sx={{ mb: 1 }}>
    <FormControlLabel
      sx={{ color: (theme: ITheme) => (error ? theme.palette.red.A700 : theme.palette.corporateBlue), alignItems: 'flex-start' }}
      control={
        <Checkbox
          sx={{ color: (theme: ITheme) => (error ? theme.palette.red.A700 : theme.palette.corporateBlue) }}
          checked={value}
          onChange={() => onChange(fieldKey, !value)}
        />
      }
      label={
        <Box>
          {typeof label === "string" ? (
            <Typography variant="form-label" sx={{ fontWeight: "normal" }}>
              {label}
              {required && (
                <Typography component="span" sx={{ color: (theme: ITheme) => theme.palette.red.A700, ml: 0.5 }}>
                  *
                </Typography>
              )}
            </Typography>
          ) : (
            <Box>
              {label}
              {required && (
                <Typography component="span" sx={{ color: (theme: ITheme) => theme.palette.red.A700, ml: 0.5 }}>
                  *
                </Typography>
              )}
            </Box>
          )}
        </Box>
      }
    />
  </Box>
);
